export const dates = [
  {
    name: 'ESTA SEMANA',
    value: 'semana'
  },
  {
    name: 'ESTE MÊS',
    value: 'mes'
  },
  {
    name: 'MÊS ANTERIOR',
    value: 'mes_anterior'
  },
  {
    name: 'ULTIMOS 3 MESES',
    value: 'tree_mounth'
  },
  {
    name: 'ULTIMOS 6 MESES',
    value: 'six_mounth'
  },
  {
    name: 'ESTE ANO',
    value: 'year'
  },
  {
    name: 'PERSONALIZADO',
    value: 'custom'
  }
]

export const ponto = [
  {
    name: 'GERAL',
    value: 'general'
  },
  {
    name: 'ENTRADA',
    value: 'entrada'
  },
  {
    name: 'SAÍDA PARA ALMOÇO',
    value: 'almoco'
  },
  {
    name: 'RETORNO DO ALMOÇO',
    value: 're_almo'
  },
  {
    name: 'INTERVALO',
    value: 'intervalo'
  },
  {
    name: 'RETORNO',
    value: 'return'
  },
  {
    name: 'FIM DO EXPEDIENTE',
    value: 'fim'
  },
  {
    name: 'HORAS EXTRAS',
    value: 'extras'
  }
]